import styled from 'styled-components';

import { colors } from 'src/utils';

export const Wrapper = styled.div`
  background-color: ${colors.red[500]};
  color: #fff;
  padding: 11px;
  position: fixed;
  bottom: 0;
  text-align: center;
  width: 100%;
  z-index: 999;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  svg {
    width: 20px;
  }
`;
